import { styled, TextField, TextFieldProps } from '@mui/material'
import {
  HeaderText,
  StyledDialog,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle,
  Title,
} from '.'
import {
  ChangeEvent,
  useCallback,
  useMemo,
  useState,
  KeyboardEvent,
  useEffect,
} from 'react'
import { colorPalette } from '../../../../style/colorPalette'
import { intl } from '../../../../../i18n'
import { Button } from '../../../../components/buttons'
import { ProjectPlanSelect } from './ProjectPlanSelect'
import { ProgressOverviewPageConfig } from '../../../../../domain/entity/version-report/VersionReportTemplateEntity'

type MasterScheduleConfigDialogProps = {
  open: boolean
  onClose: () => void
  config: ProgressOverviewPageConfig
  updateConfig: (leafUuids: string[]) => void
  snapshotUuid: string
}

export const MasterScheduleConfigDialog = ({
  open,
  onClose,
  config,
  updateConfig,
  snapshotUuid,
}: MasterScheduleConfigDialogProps) => {
  const [leafUuids, setLeafUuids] = useState<string[]>([])
  useEffect(() => {
    setLeafUuids(config.targetUuids)
  }, [config.targetUuids])
  const updateLeafUuid = useCallback((uuid: string, selected: boolean) => {
    setLeafUuids(prev => {
      const filtered = prev.filter(v => v !== uuid)
      if (selected) {
        return [...filtered, uuid]
      }
      return filtered
    })
  }, [])
  const onSubmit = useCallback(() => {
    updateConfig(leafUuids)
    onClose()
  }, [leafUuids, onClose, updateConfig])

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="lg">
      <StyledDialogTitle>
        <Title>マスタースケジュールの設定変更</Title>
      </StyledDialogTitle>
      <StyledDialogContent>
        <GridWithHeader>
          <HeaderText>表示対象の工程</HeaderText>
          <GridWrapper>
            <ProjectPlanSelect
              snapshotUuid={snapshotUuid}
              selectedUuids={leafUuids}
              updateSelectedUuid={updateLeafUuid}
            />
          </GridWrapper>
        </GridWithHeader>
      </StyledDialogContent>
      <StyledDialogActions>
        <Button onClick={onSubmit} colorPattern="skyBlue">
          設定を変更する
        </Button>
        <Button onClick={onClose} colorPattern="monotone" variant="outlined">
          {intl.formatMessage({ id: 'dialog.cancel' })}
        </Button>
      </StyledDialogActions>
    </StyledDialog>
  )
}

const GridWrapper = styled('div')({
  width: '600px',
  height: '500px',
})

const GridWithHeader = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
})
